import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import {
  RouterProvider,
  createBrowserRouter,
} from 'react-router';
import '../theme/scss/styles.scss';
import { isMobile } from 'react-device-detect';
import {
  getLayoutByRole, getRouteByRole, calculateBaseRoute, getUserRole,
} from '../utils/routeByRoles';
import { endLoadApp, initApp } from '../modules/System/actions';
import { getAuthorizedData } from '../modules/Authorized/reducer';
import ErrorPage from '../modules/System/components/ErrorPage';
import { authorizedCheck, authorizedRefresh } from '../modules/Authorized/actions';
import { responseLogWithNotification } from '../utils/utils';
import { AUTHORIZED_MODULE } from '../configs/moduleNames';

export default function Main() {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const {
    loggedIn, authorizedData, loadingAuthorizedCheck, loginProcess,
  } = useSelector(getAuthorizedData);
  const rawAuthorizedData = useSelector(state => state[AUTHORIZED_MODULE]?.authorizedData || {});
  const currentUser = rawAuthorizedData?.data || rawAuthorizedData || {};
  const permissions = currentUser && currentUser.role && currentUser.role.permissions ? currentUser.role.permissions : {};
  const currentRole = getUserRole(rawAuthorizedData);
  useEffect(() => {
    dispatch(initApp());
    document.title = formatMessage({ id: 'app.title' });
    if (loggedIn) {
      dispatch(authorizedCheck())
        .then(() => {
          setTimeout(() => { dispatch(endLoadApp()); }, 800);
        })
        .catch(responseLogWithNotification);
    } else if (!loginProcess && !loadingAuthorizedCheck) {
      dispatch(endLoadApp());
    }
  }, [dispatch, loggedIn, formatMessage]);

  useEffect(() => {
    if (!loggedIn) {
      return undefined;
    }

    const refreshInterval = window.setInterval(() => {
      dispatch(authorizedRefresh()).catch(() => {});
    }, 30000);

    return () => window.clearInterval(refreshInterval);
  }, [dispatch, loggedIn]);

  const currentRoutes = getRouteByRole(loggedIn, permissions, rawAuthorizedData, isMobile);
  // const currentRoutesByMenu = getRouteByRole(loggedIn, permissions, null, isMobile, true);
  const CurrentLayout = getLayoutByRole(loggedIn, isMobile);
  calculateBaseRoute(true, permissions, rawAuthorizedData, isMobile, true);
  const routes = currentRoutes.reduce((acc, currentRoute) => {
    const route = { ...currentRoute };
    if (currentRoute && currentRoute.children && currentRoute.children.length) {
      route.children = [];
      return [...acc, ...currentRoute.children, route];
    }
    return [...acc, route];
  }, []);
  const router = createBrowserRouter([
    {
      element: <CurrentLayout currentRoutes={currentRoutes} currentRoutesByMenu={currentRoutes} />,
      children: routes,
      errorElement: <ErrorPage />,
    },
  ]); // todo по идее можно сделать разделение всех страниц по своим лаяутам. Но вот например у некоторых урлов может быть разные лаяуты
  return (
    <RouterProvider key={`${loggedIn}-${currentRole || 'pending'}`} router={router} />
  );
}
